import React from 'react';

const LogoPreloader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-gray-50">
      <div className="text-center">
        {/* Animated Logo Container */}
        <div className="relative">
          {/* Pulse Ring Animation */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 rounded-full border-4 border-blue-400 animate-ping opacity-20"></div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-28 h-28 rounded-full border-4 border-blue-500 animate-pulse"></div>
          </div>
          
          {/* Logo Image with Scale Animation */}
          <div className="relative z-10 w-24 h-24 mx-auto mb-6 animate-bounce-slow">
            <div className="w-full h-full rounded-full bg-white shadow-2xl p-3 flex items-center justify-center overflow-hidden">
              <img 
                src="/logo.jpg" 
                alt="G.A Technology Logo" 
                className="w-full h-full object-contain animate-pulse"
              />
            </div>
          </div>
        </div>

        {/* Company Name with Fade Animation */}
        <div className="mt-8 animate-fade-in">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            G.A Technology & Power City
          </h2>
          <p className="text-sm text-gray-600">Loading your experience...</p>
        </div>

        {/* Loading Dots */}
        <div className="flex justify-center items-center space-x-2 mt-6">
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

        {/* Progress Bar */}
        <div className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden mt-6 mx-auto">
          <div className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full animate-progress"></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes progress {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }

        .animate-progress {
          animation: progress 1.5s infinite;
        }
      `}</style>
    </div>
  );
};

export default LogoPreloader;
